import { render, staticRenderFns } from "./EditSurveyTemplate.vue?vue&type=template&id=4ccea18f&scoped=true"
import script from "./EditSurveyTemplate.vue?vue&type=script&lang=js"
export * from "./EditSurveyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccea18f",
  null
  
)

export default component.exports